import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Checkbox from './Checkbox';
import { BookButton } from './BookButtons';

const Backdrop = styled.div`
  background: #cccccc99;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: ${(props) => props.maxHeight}px;
  display: flex;
  z-index: 1000;
  margin: 0 !important;
  cursor: default;
  justify-content: center;
  align-items: center;
`;

const ModalWrapper = styled.div`
  background: #f9f9f9;
  border-radius: 0.5rem;
  z-index: 1500;
  max-width: 450px;
  box-shadow: 4px 4px 5px #888888;
`;

const ModalTitle = styled.div`
  padding: 1rem 1rem 1rem 1.5rem;
  border-bottom: 1px solid #eee;
  display: flex;
`;

const ModalBottom = styled.div`
  padding: 1rem 1rem 1rem 1.5rem;
  border-top: 1px solid #eee;
  display: flex;
`;

const ModalBox = styled.div`
  padding: 1rem 1rem 1rem 1.5rem;
  user-select: none;
`;

const AdmissionPolicyModal = ({ changeModalState, modalProps }) => {
  const [checked, setChecked] = useState(false);
  const xModalState = (e) => {
    e.preventDefault();
    e.stopPropagation();

    changeModalState({ isOpen: false, props: {} });
  };

  const root = document.getElementById('root');
  const modal = document.getElementById('modals');

  return ReactDOM.createPortal(
    <Backdrop
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      maxHeight={root.clientHeight}
    >
      <ModalWrapper>
        <ModalTitle>
          <div>Admission Policy</div>
          <FontAwesomeIcon
            icon="times"
            style={{ marginLeft: 'auto', cursor: 'pointer' }}
            onClick={(e) => xModalState(e)}
          />
        </ModalTitle>
        <ModalBox>
          <Checkbox onChange={() => setChecked((prevState) => !prevState)} checked={checked} />
          Please tick to confirm that you understand this activity is subject to
          <a> </a>
          <a
            style={{
              cursor: 'pointer',
              fontWeight: 800,
              textDecoration: 'underline',
            }}
            onClick={() =>
              window.open(modalProps.admissionsPolicyUrl, '_blank', 'noreferrer', 'noopener')
            }
          >
            local admission policies (click to view).
          </a>
        </ModalBox>
        <ModalBottom>
          <BookButton
            disabled={!checked}
            admissionModal
            onClick={() => {
              window.open(modalProps.url, '_blank', 'noopener,noreferrer');
            }}
          >
            {modalProps.buttonText}
          </BookButton>
        </ModalBottom>
      </ModalWrapper>
    </Backdrop>,
    modal
  );
};

AdmissionPolicyModal.propTypes = {
  changeModalState: PropTypes.func,
  modalProps: PropTypes.object,
};

export default AdmissionPolicyModal;
